<template>
<div>
  <v-layout >
    <!-- <v-card-title >
      Last two weeks
    </v-card-title> -->
    <v-flex xs12 >
      <v-card tile flat v-if='loading && appointmentCount === 0' >
        <v-card-text class='text-xs-center' >
          <v-progress-circular color='amber' class='ma-4 pa-4' size=42 width="2" indeterminate ></v-progress-circular>
          <h3 class='subheading' >{{ $t('loading') }}</h3>
        </v-card-text>
      </v-card>
      <template v-else >
        <v-card :flat='$vuetify.breakpoint.xs' v-if='appointmentCount > 0' >
          <v-card-title>
            <v-menu >
              <span slot='activator' >
                <v-icon small >expand_more</v-icon>
                <span v-if='mainchartId === "value"' >
                  {{ $t('mainchart.titles.value') }}
                </span>
                <span v-else >
                  {{ $t('mainchart.titles.count') }}
                </span>
              </span>
              <v-list dense>
                <v-list-tile @click='mainchartId = "value"' >
                  <v-list-tile-title>
                    {{ $t('mainchart.titles.value') }}
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click='mainchartId = "count"' >
                  <v-list-tile-title>
                    {{ $t('mainchart.titles.count') }}
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-btn small @click='chartType="bar"' icon >
              <v-icon small >bar_chart</v-icon>
            </v-btn>
            <v-btn small @click='chartType="area"' icon >
              <v-icon small >show_chart</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <h3 class='subheader' >{{dateRangeFormatted}}</h3>
          </v-card-title>
          <apex-chart
            height='200px'
            width="100%"
            :type="chartType"
            :options="options"
            :series="series" >
          </apex-chart>
        </v-card>
        <v-card v-else >
          <v-layout style='background-image:url("/static/img/placeholders/analyza_data_and_chart.png"); background-repeat: no-repeat; background-attachment: fixed; background-position: right top; ' >
            <v-flex xs6 class='text-xs-center'>
              <h3 class='headline mt-4 pa-4' >Looks like you don't have any recent appointments</h3>
              <v-card-actions >
                <v-btn
                  @click="openGlobalDialog(true, 'QuickCreate')"
                  large color='success' class='ma-4' >Create an appointment</v-btn>
                <v-btn
                  to='/settings/get-online'
                  large color='primary' class='ma-4' >Get online bookings</v-btn>
              </v-card-actions>

            </v-flex>
            <v-flex class='text-xs-right mr-4'>
            </v-flex>
          </v-layout>
        </v-card>
      </template>
    </v-flex>
  </v-layout>
  <!-- <v-layout>
    <v-flex xs12>
      <v-list dense class='pa-0 pb-2'>
        <v-progress-linear v-model='setupProgress' color='amber' class='ma-0' ></v-progress-linear>
        <v-subheader class='subheading'>
          <v-icon small class='mr-2' >help</v-icon>
          Need some help?</v-subheader>
        <v-list-tile >
          <v-list-tile-content>
            <v-list-tile-title>{{configureTodos[0].title}}</v-list-tile-title>
            <v-list-tile-sub-title>{{configureTodos[0].subtitle}}</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action >
            <v-btn flat >Skip</v-btn>
          </v-list-tile-action>
          <v-list-tile-action >
            <v-btn flat color='primary' >Do it</v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-footer class='pl-3' >
        Want help getting set up? We can help configure your account
        <v-spacer></v-spacer>
        <v-btn
          href='https://appointmentguru.typeform.com/to/oJyKRS'
          target='_blank'
          color='primary' small >Do it for me
          <v-icon small class='ml-1' >open_in_new</v-icon>
        </v-btn>
      </v-footer>
    </v-flex>
  </v-layout> -->
  <v-layout row wrap fill-height class='mt-2' >
    <v-flex
       column class='white pa-0'
       xs12 sm12 md6 :md12='appointmentCount===0' >
      <v-card tile dark flat style='min-height:238' >
        <v-card-title class="pt-0">
          <v-flex class='mt-3'>
            <div class="title font-weight-light mb-2">{{ $t('metrics.titles.count') }}</div>
            <div class=" font-weight-light grey--text">{{ dateRangeFormatted }}</div>
          </v-flex>
          <v-flex class='text-xs-right headline  pt-2'>
          {{appointmentCount}}
          </v-flex>
          <!-- <span class="caption grey--text font-weight-light">last registration 26 minutes ago</span> -->
        </v-card-title>
        <v-card-title class="pt-0" >
          <v-flex class='mt-3' >
            <div class="title font-weight-light mb-2">{{ $t('metrics.titles.value') }}</div>
            <div class=" font-weight-light grey--text">{{ $t('metrics.subtitles.value') }}</div>
          </v-flex>
          <v-flex xs12 class='text-xs-right headline pt-2'>
          {{ formatCurrency(settings.currency, appointmentValue) }}
          </v-flex>
          <!-- <span class="caption grey--text font-weight-light">last registration 26 minutes ago</span> -->
        </v-card-title>
      </v-card>
    </v-flex>
    <v-flex
      xs12 sm12 md6
      column class='white pa-0' v-if='appointmentCount > 0' >
      <v-card tile flat >
        <apex-chart
          height=250
          type="radialBar"
          :options="statusBreakdown.chartOptions"
          :series="statusBreakdown.series" >
        </apex-chart>
      </v-card>
    </v-flex>

  </v-layout>
  <!-- <v-layout>
    <v-flex xs12>
      <v-card tile full-width class='mt-2' >
        <h3 class='overline pa-3' >Appointments</h3>
        <apex-chart
          type='heatmap'
          height='250'
          :options='heatmap.options'
          :series='heatmap.series' >
        </apex-chart>
      </v-card>
    </v-flex>
  </v-layout> -->
</div>
</template>

<script>
import ApexChart from 'vue-apexcharts'
import {STATUSES} from '@/store/constants'
import {mapGetters} from 'vuex'

export default {
  name: 'Welcome',
  components: {ApexChart},
  props: {
    value: { type: Object },
    loading: { type: Boolean, default: false }
  },
  data () {
    return {
      mainchartId: 'count',
      chartType: 'bar',
      STATUSES: STATUSES,
      setupProgress: 40,
      configureTodos: [
        {
          id: 'profession',
          title: 'Enter a profession',
          subtitle: 'Important information for people making appointments with you',
          status: 'todo' // done, todo, skip
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'settings'
    ]),
    dateRangeFormatted () {
      if (this.value) {
        let range = this.getObjectPath(this.value, 'charts.range', {})
        return `${range.from} - ${range.to}`
        // return `${this.dateformat(range.from)} - ${this.dateformat(range.to)}`
      }
      return ''
    },
    appointmentCount () {
      return this.countChart.reduce((total, item, index) => {
        return total + item.y
      }, 0)
    },
    appointmentValue () {
      return this.valueChart.reduce((total, item, index) => {
        return total + item.y
      }, 0)
    },
    mainChart () {
      if (this.mainchartId === 'value') {
        return {
          name: 'Appointment value',
          data: this.valueChart
        }
      } else {
        return {
          name: 'Appointments',
          data: this.countChart
        }
      }
    },
    valueChart () {
      if (this.value) {
        return this.getObjectPath(this.value, 'charts.appointments.value', [])
      }
      return []
    },
    countChart () {
      if (this.value) {
        return this.getObjectPath(this.value, 'charts.appointments.count', [])
      }
      return []
    },
    breakdownChart () {
      if (this.value) {
        return this.getObjectPath(this.value, 'charts.status_breakdown.count', {})
      }
      return {}
    },
    options () {
      // let vm = this
      return {
        chart: {
          id: 'homepage-welcome',
          toolbar: { show: false },
          events: {
            click: (event, chartContext, config) => {
              let dataIndex = config.dataPointIndex
              let point = this.series[0].data[dataIndex]
              this.$emit('chart:appointments:clicked', point)
            }
          }
        },
        yaxis: {
          labels: { show: false }
        },
        xaxis: {
          labels: { show: false },
          type: 'datetime'
        },
        annotations: {
          xaxis: [ // today
            { x: new Date().getTime() }
          ]
        }
      }
    },
    series () {
      return [
        this.mainChart
      ]
    },
    breakdownSeries () {
      let values = Object.values(this.breakdownChart)
      if (values.length > 0) {
        let ordered = values.sort(function (a, b) { return b - a })
        let max = ordered[0]
        let multiplier = (100 / max)
        return Object.values(this.breakdownChart).map((item) => {
          return Math.round(item * multiplier)
        })
      }
      return []
      // let values = Object.values(this.breakdownChart)
      // let total = values.reduce((count, item) => {
      //   return count + item
      // }, 0)
      // return values.map((item) => {
      //   return Math.round(item / total * 100)
      // })
    },
    breakdownLabels () {
      return Object.keys(this.breakdownChart)
    },
    breakdownColors () {
      let keys = Object.keys(this.breakdownChart)
      return keys.map((key) => {
        if (key in STATUSES) {
          return STATUSES[key].bright
        }
        return '#1ab7ea'
      })
    },
    statusBreakdown () {
      let vm = this
      return {
        series: this.breakdownSeries,
        chartOptions: {
          plotOptions: {
            radialBar: {
              offsetY: -10,
              startAngle: 0,
              endAngle: 270,
              hollow: {
                margin: 5,
                size: '30%',
                background: 'transparent',
                image: undefined
              },
              dataLabels: {
                name: {
                  fontSize: '16px'
                },
                value: {
                  fontSize: '12px',
                  offsetY: 0
                },
                total: {
                  show: true,
                  label: 'Total',
                  formatter: function (w) {
                    // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                    return vm.appointmentCount
                  }
                }
              }
            }
          },
          colors: this.breakdownColors,
          labels: this.breakdownLabels,
          legend: {
            show: true,
            floating: true,
            fontSize: '10px',
            position: 'left',
            offsetX: 10,
            offsetY: 0,
            labels: {
              useSeriesColors: true
            },
            markers: {
              size: 0
            },
            formatter: function (seriesName, opts) {
              // console.log(seriesName)
              if (seriesName in STATUSES) {
                // let value = opts.w.globals.series[opts.seriesIndex]
                let value = Object.values(vm.breakdownChart)[opts.seriesIndex]
                return STATUSES[seriesName].title + ': ' + value
              }
              return seriesName
            },
            itemMargin: {
              horizontal: 1
            }
          },
          responsive: [{
            breakpoint: 480,
            options: {
              legend: {
                show: false
              }
            }
          }]
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        mainchart: {
          titles: {
            value: 'Appointment value',
            count: 'Number of appointments'
          }
        },
        metrics: {
          titles: {
            count: 'Appointments',
            value: 'Value'
          },
          subtitles: {
            value: 'Total price of appointments'
          }
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Welcome.vue?7d174f7a